/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form"
import { farazSMS, farazSendSMS } from '@aspianet/faraz-sms'

import Menu from '../../../components/CustomerClub/Menu'

import smsIcon from '../../../assets/svg/Sms.svg'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'
import { get } from '../../../services/http'

function index() {
  document.title = 'ارسال sms'

  const [clickButton, setClickButton] = useState(false)
  const [clickButtonGroup, setClickButtonGroup] = useState(false)

  const [ccusers, setCCuser] = useState([])
  const [users, setUser] = useState([])

  const [selectGroup, setSelectGroup] = useState('')
  const [messageGroup, setMessageGroup] = useState([])

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/ccusers/all?token=${token}`)
      .then(response => {
        const ccuser = []
        response.data.data.map((item) => {
          return ccuser.push(`0${item.phoneNumber}`)
        })
        setCCuser(ccuser)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/users/all?token=${token}`)
      .then(response => {
        const user = []
        response.data.data.map((item) => {
          return user.push(`0${item.phoneNumber}`)
        })
        setUser(user)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  farazSMS.init("C2R1t2kJNUKkTN5R2zgSeYnjpkhdxt1Gn24Q5ImtwSY=")

  const onSubmit = async (data, e) => {
    e.preventDefault()
    setClickButton(true)
    const result = await farazSendSMS( '3000505', [ data.phone ], `${data.textSms}` )
    console.log(result)
    if (result.status) {
      setClickButton(false)
      reset()
      notify('success', 'ارسال شد')
    } else {
      notify('error', 'خطا در ارسال اطلاعات')
    }
  }

  const submitHandlerGroup = async (e) => {
    e.preventDefault()
    setClickButtonGroup(true)
    if (selectGroup === 'ccuser') {
      const result = await farazSendSMS( '+989999179485', ccusers,  messageGroup)
      if (result.status) {
        setClickButtonGroup(false)
        notify('success', 'ارسال شد')
      } else {
        notify('error', 'خطا در ارسال اطلاعات')
      }
    } else if (selectGroup === 'user') {
      const result = await farazSendSMS( '+989999179485', users ,  messageGroup)
      if (result.status) {
        setClickButtonGroup(false)
        notify('success', 'ارسال شد')
      } else {
        notify('error', 'خطا در ارسال اطلاعات')
      }
    } else {
      notify('error', 'نوع گروه ارسالی را مشخص کنید')
    }
  }

  const groupHandlerSelect = (e) => {
    setSelectGroup(e.target.value)
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'sms'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={smsIcon} alt='smsIcon' />
              </div>
              <div className='text'>
                ‌‌ارسال sms
              </div>
            </div>
            <div className="left">
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * ارسال sms میتوانید به صورت تکی یا به صورت گروهی ارسال شود.
            </div>
            <div className='lineTitle'>
              <hr />
              sms تکی 
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>شماره موبایل * :</label>
                <input id='offCodeName' {...register("phone", { required: true, minLength: 10 })} maxLength={11} className='ltrdirection' type='text' placeholder='09...' />
                <small id='offCodeNameAlert'>شماره موبایل باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='resturantEmail'>متن پیغام * :</label>
                <textarea id='resturantEmail' {...register("textSms", { required: true, minLength: 5 })} rows={5} placeholder='پیغام ...' />
                <small id='resturantAlert'>متن پیغام ما باید وارد شود</small>
              </div>
            </div>
            <button style={clickButton ? { backgroundColor: 'gray' } : {}} className='createButton'>{clickButton ? 'در حال ارسال ...' : 'ارسال'}</button>
          </form>

          <form className='form'>
            <div className='lineTitle'>
              <hr />
              sms گروهی 
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>گروه ارسالی * :</label>
                <select id='categoryName' onChange={groupHandlerSelect}>
                  <option value="">انتخاب کنید</option>
                  <option value="ccuser">مشتریان (تعداد : {ccusers.length})</option>
                  <option value="user">کاربران (تعداد : {users.length})</option>
                </select>
                <small id='offCodeNameAlert'>شماره موبایل باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='resturantEmail'>متن پیغام * :</label>
                <textarea id='resturantEmail' onChange={e => setMessageGroup(e.target.value)} rows={5} placeholder='پیغام ...' />
                <small id='resturantAlert'>متن پیغام ما باید وارد شود</small>
              </div>
            </div>
            <button style={clickButtonGroup ? { backgroundColor: 'gray' } : {}} className='createButton' onClick={submitHandlerGroup}>{clickButtonGroup ? 'در حال ارسال ...' : 'ارسال'}</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index
